<div [formGroup]="searchIvrDonationDetailsListForm">
  <div class="ibox-content m-b-sm border-bottom">


    <div *ngIf="!contactID " class="row" style="padding: 10px 15px;">
      <div class="example-container" *ngIf="!contactID ||contactID == 0">
        <div fxLayout="row">
          <mat-select-multiple-dropdown [keyProperty]="'id'" [titleProperty]="'title'"
            (selectChange)="indexService.selectionChanged($event)"
            [listControl]="searchIvrDonationDetailsListForm.controls.donationCategoryIDs" [placeholder]="'קטגוריה...'"
            [list]="servicesData.DonationCategories">
          </mat-select-multiple-dropdown>
          &nbsp;&nbsp;
          <div style="width:  90px !important; min-width: auto;" class="input-group mb-3">
            <label>מטבע...</label>
            <mat-select style="width:  90px !important; min-width: auto;" class="form-control narrow"
              (selectChange)="indexService.selectionChanged($event)" placeholder="מטבע..." formControlName="currency">
              <mat-option value=""></mat-option>
              <mat-option *ngFor="let c of servicesData.Currencies" [value]="c.value">
                {{c.name}}
              </mat-option>
            </mat-select>
          </div>
          &nbsp;&nbsp;
          <date-input-range [placeHolderStart]="'החל מתאריך:'" [placeHolderEnd]="'עד לתאריך:'"
            [dateRangeCtrl]="searchIvrDonationDetailsListForm.controls.dateRange">Loading...
          </date-input-range>
          &nbsp;&nbsp;
          <mat-select-multiple-dropdown [keyProperty]="'value'" [titleProperty]="'name'"
            (selectChange)="indexService.selectionChanged($event)"
            [listControl]="searchIvrDonationDetailsListForm.controls.statusPayments" [placeholder]="'סטטוס תשלום...'"
            [list]="servicesData.StatusPayments">
          </mat-select-multiple-dropdown>
          &nbsp;&nbsp;
          <auto-complete apply-enter [controllerName]="'Contacts'" [placeholder]="'איש...'"
            [formGroupModel]="searchIvrDonationDetailsListForm"
            [idControl]="searchIvrDonationDetailsListForm.controls.contactID"
            [nameControl]="searchIvrDonationDetailsListForm.controls.contactName"></auto-complete>
          &nbsp;&nbsp;
          <div class="input-group mb-3">
            <label>סטטוס ביצוע...</label>
            <mat-select class="form-control" (selectChange)="indexService.selectionChanged($event)"
                placeholder="סטטוס ביצוע..." formControlName="isHandlingDate">
                <mat-option [value]="null">הכל</mat-option>
                <mat-option [value]="true">בוצע</mat-option>
                <mat-option [value]="false">לא-בוצע</mat-option>
            </mat-select>
        </div>
        &nbsp;&nbsp;
          <div class="input-group mb-3">
            <label>הקלטה...</label>
            <mat-select class="form-control" (selectChange)="indexService.selectionChanged($event)"
                placeholder="הקלטה..." formControlName="containsAudio">
                <mat-option [value]="null">הכל</mat-option>
                <mat-option [value]="true">הקלטה</mat-option>
                <mat-option [value]="false">ללא-הקלטה</mat-option>
            </mat-select>
        </div>
        &nbsp;&nbsp;
          <span fxFlex class="example-fill-remaining-space"></span>
          <div *ngIf="indexService && indexService.results" style="BORDER: SOLID; padding: 3px 10px;BACKGROUND: antiquewhite;">
            <div *ngFor="let item of indexService.results" >
              <p style="font-weight: bold; ">{{ item.key }}:</p>
              <p>{{ item.value | number}}</p>
            </div>
          </div>
          <div fxLayoutAlign="start center" style="text-align:left" class="example-button-row">
            <button *ngIf="indexService.selection && indexService.selection.selected.length >= 1"
              class="btn btn-outline btn-success  dim" type="button"
              style="width: min-content; font-weight: 500; color:blue" (click)="updateHandlingDate()">
              עדכן תאריך טיפול ל-{{indexService.selection.selected.length}} רשומות נבחרות
            </button>
            &nbsp;&nbsp;
            &nbsp;&nbsp;
            <button mat-mini-fab color="primary" title="סנן" (click)="indexService.selectionChanged($event)"> <i
                class="fa fa-filter"></i></button>
            &nbsp;
            <button mat-mini-fab color="primary" title="נקה סינונים" (click)="indexService.clerFilter()"><i
                class="material-icons">clear</i></button>
          </div>
        </div>
      </div>
    </div>

  </div>

  <div class="example-container" *ngIf="indexService">

    <div class="bounds">
      <div class="content" style="height: 70%; overflow: auto" fxFlexFill loading-status
        [stopLoadingWhen]="stopLoadingPoints || sourceList">


        <cdk-virtual-scroll-viewport testCDK [full-height]="!contactID" #test itemSize="10"
          [ngStyle]="{'height':  'calc(100vh - '+ actualMinusHeight +'px)'}">

          <mat-table #table style="width: 100%;" *ngIf="indexService?.sourceList; else loading"
            [dataSource]="indexService.sourceList" (matSortChange)="indexService.sortData($event)" class="example-table"
            matSort matSortDisableClear matSortDirection="asc">
            <ng-container matColumnDef="select">
              <mat-header-cell style=" padding-right: 0;" *matHeaderCellDef>
                <span style="color: #FFFFFF; background-color: blue;" class="label label-primary"
                  *ngIf="indexService?.selection?.selected?.length > 0">{{ indexService?.selection?.selected?.length
                  }}</span>
              </mat-header-cell>
              <mat-cell *matCellDef="let row">
                <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? indexService.rowToggle(row) : null"
                  [checked]="indexService.selection.isSelected(row)">
                </mat-checkbox>
                <i class="fa fa-check" *ngIf="row.handlingDate != null" matSuffix [matTooltip]="('תאריך טיפול: ' + row.jewishHandlingDate)"
                   style="color: green; font-size: 75%; margin: 0 auto;"></i>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="buttons">
              <mat-header-cell *matHeaderCellDef>...</mat-header-cell>
              <mat-cell *matCellDef="let row">
                <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <a mat-menu-item
                    [routerLink]="[ '', {outlets: {popup: [ 'ivrDonationDetails', row.ivrDonationDetailID]}}]">
                    <mat-icon>pageview</mat-icon>
                    <span>פרטים מלאים</span>
                  </a>

                  <a mat-menu-item
                    [routerLink]="['', {outlets: {popup: ['ivrDonationDetails', row.ivrDonationDetailID, 'edit']}}]">
                    <mat-icon>edit</mat-icon>
                    <span>עריכה</span>
                  </a>

                  <a mat-menu-item>
                    <mat-icon>information</mat-icon>
                    <model-info style="padding: 4px" [dataProvider]="ivrDonationDetailsData"
                      [id]="row.ivrDonationDetailID" [title]="'מידע רשומה'">
                    </model-info>
                  </a>
                </mat-menu>
              </mat-cell>
            </ng-container>


            <ng-container matColumnDef="ivrDonationDetailID">
              <mat-header-cell *matHeaderCellDef mat-sort-header> מזהה
              </mat-header-cell>
              <mat-cell *matCellDef="let row" data-label="מזהה">
                <a [routerLink]="[ '', {outlets: {popup: [ 'ivrDonationDetails', row.ivrDonationDetailID]}}]">
                  {{ row.ivrDonationDetailID }}
                </a>
                  <mat-icon *ngIf="row.containsAudio == true" matSuffix matTooltip="קובץ הקלטה מצורף"
                  style="color: gray; font-size: 95%; margin: 0 auto;">attach_file</mat-icon>

              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="lastName">
              <mat-header-cell *matHeaderCellDef mat-sort-header> שם איש </mat-header-cell>
              <mat-cell style="font-weight: 500;" *matCellDef="let row" data-label="שם איש">
                <a [routerLink]="[ '/contacts', row.contactID]">{{ row.firstName }} {{ row.lastName }}</a>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="shtibelName">
              <mat-header-cell *matHeaderCellDef mat-sort-header> שטיבל </mat-header-cell>
              <mat-cell *matCellDef="let row" data-label="שטיבל">
                {{row.shtibelName}}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="phoneNumber">
              <mat-header-cell *matHeaderCellDef mat-sort-header> טלפון
                מתקשר
              </mat-header-cell>
              <mat-cell *matCellDef="let row" data-label="טלפון מתקשר" style="direction: ltr; padding-left: 24px;">
                <mat-icon matSuffix matTooltip="העתק מספר" [cdkCopyToClipboard]="(row.phoneNumber)"
                  style="color: gray; font-size: 75%; margin: 0 auto;">content_copy</mat-icon>
                {{row.phoneNumber | phone}}
              </mat-cell>
            </ng-container>


            <ng-container matColumnDef="title">
              <mat-header-cell *matHeaderCellDef mat-sort-header> קטגוריה </mat-header-cell>
              <mat-cell *matCellDef="let row" data-label="קטגוריה">
                <a [routerLink]="[ '', {outlets: {popup: [ 'donationCategories', row.donationCategoryID]}}]">
                  <b> {{ row.title }} </b>
                </a>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="createDate">
              <mat-header-cell *matHeaderCellDef mat-sort-header> תאריך ושעת תרומה </mat-header-cell>
              <mat-cell *matCellDef="let row" data-label="תאריך ושעת תרומה">
                {{ row.createDate | orgDate:'dateTime' }}
                <br>
                {{ row.jewishCreateDate }}
              </mat-cell>
            </ng-container>


            <ng-container matColumnDef="amount">
              <mat-header-cell *matHeaderCellDef mat-sort-header> סכום</mat-header-cell>
              <mat-cell *matCellDef="let row" data-label="סכום">
                {{ row.amount | number}}{{row.currency| currency:'usd':true:'1.0-0' }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="qty">
              <mat-header-cell *matHeaderCellDef mat-sort-header> תשלומים</mat-header-cell>
              <mat-cell *matCellDef="let row" data-label="תשלומים">
                {{ row.qty }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="statusPayment">
              <mat-header-cell *matHeaderCellDef mat-sort-header>סטטוס</mat-header-cell>
              <mat-cell *matCellDef="let row" data-label=" 'amount',">
                <i class="fa fa-circle text-navtext-navy" style="font-size: 8px;" [matTooltip]="row.paymentID"
                  [ngStyle]="{'color': (row.statusPayment == 3 ? 'red' : ((row.statusPayment == 2) || (row.payMethodID == 89 && row.statusPayment == 1) ? 'green' : 'darkorange'))}"></i>&nbsp;{{
                row.statusPaymentName}}
                &nbsp;
                <a [routerLink]="[ '', {outlets: {popup: [ 'payments', row.paymentID]}}]">{{ row.paymentID}} </a>
              </mat-cell>
            </ng-container>


            <ng-container matColumnDef="commitmentID">
              <mat-header-cell *matHeaderCellDef mat-sort-header> התחייבות
              </mat-header-cell>
              <mat-cell *matCellDef="let row" data-label="התחייבות">
                <a *ngIf="row.commitmentID"
                  [routerLink]="[ '', {outlets: {popup: [ 'commitments', row.commitmentID]}}]">
                  {{ row.commitmentID }}</a>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="methodTitle">
              <mat-header-cell *matHeaderCellDef> באמצעות
              </mat-header-cell>
              <mat-cell *matCellDef="let row" data-label="באמצעות">
                <a *ngIf="row.payMethodID" [routerLink]="[ '', {outlets: {popup: [ 'payMethods', row.payMethodID]}}]">
                  {{ row.methodTitle }}</a>
                <mat-icon matSuffix matTooltip="העתק 4 ספרות אחרונות" [cdkCopyToClipboard]="(row.last4Digits)"
                  style="color: gray; font-size: 75%; margin: 0 auto;">content_copy</mat-icon>
              </mat-cell>
            </ng-container>


            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"
              (dblclick)="openSelectedRow(row.ivrDonationDetailID)">
            </mat-row>
          </mat-table>
        </cdk-virtual-scroll-viewport>
      </div>
    </div>

    <mat-paginator (page)="indexService.pageChange($event)" [showFirstLastButtons]="true" [hidePageSize]="false"
      [length]="indexService.rowsCount" [pageSize]="indexService.pageRows"
      [pageSizeOptions]="[10, 25, 30, 50, 100]"></mat-paginator>
  </div>
</div>
